import { SUPABASE_URL, SUPABASE_ANON_KEY } from '../config/env';

const supabaseRequest = async (endpoint, options = {}) => {
  const response = await fetch(`${SUPABASE_URL}${endpoint}`, {
    ...options,
    headers: {
      'apikey': SUPABASE_ANON_KEY,
      'Authorization': `Bearer ${SUPABASE_ANON_KEY}`,
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
  if (!response.ok) {
    const error = await response.json().catch(() => ({ message: 'Request failed' }));
    throw new Error(error.message || 'Request failed');
  }
  return response.json();
};

export class ServiceExecutiveService {
  static async getComplaints(executiveId) {
    try {
      const data = await supabaseRequest(`/rest/v1/rpc/service_executive_get_complaints`, {
        method: 'POST',
        body: JSON.stringify({ p_executive_id: executiveId }),
      });
      return { success: true, data: data || [], error: null };
    } catch (error) {
      console.error('Error fetching complaints:', error);
      return { success: false, data: [], error: error.message };
    }
  }

  static async getOrders(executiveId) {
    try {
      const data = await supabaseRequest(`/rest/v1/rpc/service_executive_get_orders`, {
        method: 'POST',
        body: JSON.stringify({ p_executive_id: executiveId }),
      });
      return { success: true, data: data || [], error: null };
    } catch (error) {
      console.error('Error fetching orders:', error);
      return { success: false, data: [], error: error.message };
    }
  }

  static async updateOrderStatus(orderId, status) {
    try {
      const data = await supabaseRequest(`/rest/v1/rpc/service_executive_update_order_status`, {
        method: 'POST',
        body: JSON.stringify({ p_order_id: orderId, p_status: status }),
      });
      return { success: true, data, error: null };
    } catch (error) {
      console.error('Error updating order status:', error);
      return { success: false, error: error.message };
    }
  }
}

